import { render, staticRenderFns } from "./GroupBind.vue?vue&type=template&id=005e1682&scoped=true"
import script from "./GroupBind.vue?vue&type=script&lang=js"
export * from "./GroupBind.vue?vue&type=script&lang=js"
import style0 from "./GroupBind.vue?vue&type=style&index=0&id=005e1682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e1682",
  null
  
)

export default component.exports